import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.funding_requirements.send_penny_transfer_title',
        defaultMessage: 'Send a penny transfer'
    },
    caption: {
        id: '_.funding_requirements.send_penny_transfer_caption',
        defaultMessage:
            "This confirms that you control your company's bank account."
    },
    action: {
        id: '_.funding_requirements.penny_transfer_action',
        defaultMessage: 'Complete transfer'
    }
});
